import { useAppStore } from '@booking-portal/stores/app-store';
import * as Sentry from '@sentry/vue';
import { watch } from 'vue';

export function useCustomJavascript() {
  const appStore = useAppStore();

  watch(
    () => appStore.setupData?.customJavascriptCode,
    (codeRaw) => {
      const code = codeRaw?.trim();

      if (!code) {
        removeScriptElement();
        return;
      }

      setScriptContent(code);
    },
    { immediate: true }
  );
}

const scriptId = 'custom-js' as const;

function setScriptContent(code: string) {
  // Replace the node so inline code executes again on every update.
  removeScriptElement();

  const script = document.createElement('script');
  script.id = scriptId;
  script.type = 'text/javascript';
  script.text = code;

  try {
    document.head.appendChild(script);
  } catch (error) {
    Sentry.captureException(error, { extra: { customJavascriptCode: code } });
    console.error(
      '[useCustomJavascript] Failed to inject custom JavaScript:',
      error
    );
  }
}

function removeScriptElement() {
  const existing = document.getElementById(scriptId);

  if (existing) {
    existing.remove();
  }
}
